<template>
  <div class="home">
    <carousel></carousel>
    <core-section></core-section>
    <browse-section></browse-section>
    <promotions-section></promotions-section>
    <contact></contact>
  </div>
</template>

<script>
import Carousel from '@/components/Carousel.vue'
import CoreSection from './CoreSection.vue'
import BrowseSection from './BrowseSection.vue'
import PromotionsSection from './PromotionsSection.vue'
import Contact from './Contact.vue'
export default {
  name: 'home',
  components: {
    Contact,
    Carousel,
    CoreSection,
    BrowseSection,
    PromotionsSection
  },
  data () {
    return {
    }
  },
  mounted () {
    if (!this.$ls.get('info')) {
      this.$ls.set('info', JSON.stringify({ l: this.$store.getters.id, a: this.$store.getters.groupid }))
    } else {
      const info = JSON.parse(this.$ls.get('info'))
      if (info.l !== this.$store.getters.id || info.a !== this.$store.getters.groupid) {
        this.$ls.set('info', JSON.stringify({ l: this.$store.getters.id, a: this.$store.getters.groupid }))
        this.$ls.remove('beers')
        this.$store.dispatch('CleanBeer')
      }
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue